<template>
    <div class="row grp-pd">
           <div class="col-lg-2 my-1 col-12">
             <input type="text" class="form-control"
                    v-model="barcodeText"
                    id="chat-search"
                    placeholder="Scan" aria-label="Search..."
                    aria-describedby="chat-search"
                    @keydown.enter="onScanBarcode"
                    ref="productScanField"
             />
           </div>

           <div class="col-lg-4 my-1 col-12">
             <AsyncSelect
                 :api-service="fetchProductList"
                 placeholder="Select Product"
                 v-model="selectedProduct"
                 label="text"
                 :format-label="option => option.text"
                 skip-api-on-open
                 ref="productField"
             />
           </div>
           <div class="col-lg-3"></div>
           <div class="col-lg-3 my-1  col-12">
             <v-select
                 placeholder="Select Warehouse Location"
                 :model-value="locationId"
                 @update:model-value="$emit('update:locationId', $event)"
                 :options="locations"
                 label="text"
                 :reduce="text => text.id"
             />
           </div>
         </div>
    <div class="row content-border">
        <div class="col-lg-2 bg-col-1">
          <ParentProductGroupList
              :parentGroup="parentGroup"
              :selectedGroupId="selectedGroupId"
              @selectGroup="selectGroup"
          />
        </div>
 
        <div class="col-lg-4 bg-col-2">
            <ProductGroupList
                :productList="productList"
                :companyId="companyId"
                :locationId="locationId"
                @addItem="addItem"
            />
        </div>

        <div class="col-lg-6 content-height bg-col-3">
          <div class="table-container padding-right my-1">
            <table class="table">
              <thead>
              <tr>
                <th>SL</th>
                <th>Item</th>
                <th class="text-right">Qty</th>
                <th class="text-right">Price</th>
                <th class="text-right">Amount</th>
              </tr>
              </thead>
            </table>
          </div>
            <div class="pos-right">
                <div class="pos-scroll">
                  <ProductList
                      :data="data"
                      @changeQty="changeQty"
                      @blurQty="blurQty"
                      @deleteTableItem="deleteTableItem"
                  />
                    
                    <div class="px-1 cal-border">
                        <div class="row mt-1">
                            <div class="col-lg-4">
                                <label class="text-bold">Sub Total</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <input 
                                    class="form-control text-right"
                                    :value="subTotal"
                                    type="number"
                                    readonly
                                >
                            </div>
                        </div>
                    
                        <div class="row margin-5" v-if="false">
                            <div class="col-lg-4">
                                <label class="text-bold" for="total_amount">Total VAT</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <input 
                                    class="form-control text-right"
                                    :value="subTotal + totalVat"
                                    type="number"
                                    readonly
                                >
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-4">
                                <label class="text-bold" for="total_amount">Bill Amount</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <input
                                    :value="subTotal"
                                    readonly
                                    name="total_amount"
                                    type="number"
                                    class="form-control text-right"
                                />
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-8">
                                <label class="text-bold">(Less) Round-off / Final Discount</label>
                                <div v-if="discountAmount > 0">
                                    <v-select
                                        placeholder="Select Discount Head"
                                        v-model="formData.discount_head_id"
                                        :options="discountAccHead"
                                        label="name"
                                        :reduce="name => name.id"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <vField
                                            v-model="discountPercent"
                                            name="total_amount"
                                            type="number"
                                            class="form-control text-right"
                                            placeholder="%"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <vField
                                            v-model="discountAmount"
                                            name="total_amount"
                                            type="number"
                                            class="form-control text-right"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-4">
                                <label class="text-bold">Net Bill</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <vField
                                    :model-value="grandTotal"
                                    @keyup="setDiscountAmount"
                                    name="total_amount"
                                    type="number"
                                    class="form-control text-right"
                                />
                            </div>
                        </div>
                    </div>
                  <div @click="openPaymentModal" class="pay-now-btn mt-1">
                    Pay Now
                  </div>
                </div>
            </div>
        </div>
    </div>

    <PaymentModal
        v-if="isPaymentModal"
        :grandTotal="parseFloat(grandTotal)"
        :rewardPointsAccountHeads="rewardPointsAccountHeads"
        :cashAndBank="cashAndBank"
        :contactProfile="contactProfile"
        :isSubmitting="isSubmitting"
        @close="closeModal()"
        @onSubmit="submitData"
    />
    <div ref="posReceipt">
    <teleport to="body">
      <div id="pos-print-area-portal">
        <PosReceiptPrint
            :company="company"
            :invoice="invoiceRes"
            :posPrintSize="posPrintSize"
            :customizationPdfFields="customizationPdfFields"
        />
      </div>
    </teleport>
    </div>
</template>

<script setup>
import {ref, reactive, watch, onMounted, computed, inject, provide, nextTick} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import handlePurchase from '@/services/modules/purchase';
import pdfPrinter from '@/services/utils/pdfPrinter';
import handleBarcode from '@/services/modules/barcode';
import figureFormatter from '@/services/utils/figureFormatter';
import handleCompany from '@/services/modules/company';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import ProductGroupList from "@/components/molecule/company/pos-invoice/ProductGroupList.vue";
import ProductList from "@/components/molecule/company/pos-invoice/ProductList.vue";
import ParentProductGroupList from "@/components/molecule/company/pos-invoice/ParentProductGroupList.vue";
import PaymentModal from "@/components/molecule/company/pos-invoice/PaymentModal.vue";
import PosReceiptPrint from "@/components/molecule/company/pos-invoice/PosReceiptPrint.vue";
import handleDropdowns from "@/services/modules/dropdowns";
import handleInventory from '@/services/modules/inventory';
import handlePurchaseAndSales from "@/services/modules/purchase";
import hospitalPosPdfPrinter from '@/services/utils/hospitalPosPdfPrinter';
import useInvoiceCalculations from '@/composables/useInvoiceCalculations';
import useDate from "@/services/utils/day";

const props = defineProps({
  items: Array,
  parentGroup: Array,
  locations: Array,
  contactProfileId: null,
  companyId: null,
  locationId: null,
  productId: null,
});

const emit = defineEmits(['resetIds', 'update:locationId']);

const store = useStore();
const route = useRoute();
const router = useRouter();
const date = useDate();

const products = ref([]);
const data = ref([]);
const voucher = ref('');
const companyInfo = ref({});
const cashAndBank = ref([]);
const discountAccHead = ref([]);
const accountRecHead = ref([]);
const totalVat = ref(0);
const isPaymentModal = ref(false);
const isSubmitting = ref(false);
const productList = ref([]);
const contactProfile = ref(null);
const loader = ref(false);
const selectedProduct = ref(null);
const productScanField = ref(null);
const isFromProductScan = ref(false);
const rewardPointsAccountHeads = ref([]);
const productField = ref(null);
const invoiceRes = ref({});
const company = ref({});
const barcodeQuery = ref('');
const barcode = ref('');
const qrcode = ref('');
const customizationPdfFields = ref([]);
const totals = ref({
  subTotalVal: 0,
  totalVatVal: 0,
  totalVal: 0,
})

const salesOrderId = computed(() => route.query.sales_order_id)

const {
  subTotal,
  grandTotal,
  discountAmount,
  discountPercent,
  setDiscountAmount,
  resetDiscounts,
} = useInvoiceCalculations(data, totals)

const barcodeText = ref(null);
const posPrintSize = ref(58);

const focusScanner = () => {
  nextTick(() => {
    if (productScanField.value) {
      productScanField.value.focus();
    }
  });
};

const showError = inject("showError");
const showSuccess = inject("showSuccess");

const { fetchProductDropdownList, fetchDropdownList } = handleDropdowns();
const { fetchSalesBill, ...rest } = handlePurchase();
const { fetchProductDetailsByParent } = handleInventory();
const { fetchProductList } = handlePurchaseAndSales();
const { exportToPDF } = pdfPrinter();
const { fetchCompanyInfo, fetchActiveCustomizationField, getCompanyPreferences } = handleCompany();
const { formatDate } = figureFormatter();
const { fetchBarcode } = handleBarcode();
const { exportToPDF: exportToPosPDF } = hospitalPosPdfPrinter();

const formData = ref({
  company_id: null,
  contact_profile_id: null,
  account_head_id: null,
  liability_head_id: null,
  mop_account_head_id: null,
  business_id: null,
  project_id: null,
  cost_centre_id: null,
  location_id: null,
  status: 'active',
  bill_number: '',
  date: '',
  has_item_detail: true,
  description: '',
  order_number: null,
  sales_order_master_id: null,
  sales_person_id: null,
  commission_percent: null,
  lc_number: null,
  discount_head_id: null,
  vat_amount: 0,
  sale_type: 'pos_invoice',
  receipt_type: 'pos_invoice',
  receipt_reference: '',
  points_redeemed: 0,
  item_details: [{
    product_id: null,
    name: '',
    description: '',
    quantity: 1,
    rate: 0,
    discount_percent: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
  }]
});

provide('formData', formData);

onMounted(async () => {
    if(props.parentGroup.length) {
       await getProductList();
    }
    await getAccountData();
    await getPosPrintSizeData();

    if(salesOrderId.value) {
      await fetchSalesOrderData();
    }
    focusScanner();
});

watch(() => props.locationId, () => {
  focusScanner();
});

const posReceipt = ref(null);
const printPosReceipt = () => {
  window.print();
};

const getPosPrintSizeData = async () => {
  const queryObject = {
    company_id: props.companyId,
    fields: 'pos_print_size'
  }
  const query = '?' + new URLSearchParams(queryObject).toString();

  await getCompanyPreferences(query)
      .then(res => {
        if (res.status){
          const data = res.data;
          posPrintSize.value = getInitialValue(data, 'pos_print_size')
        }
      });
}

const getInitialValue = (data, field) => {
  const item = data.find((item => item.field === field))

  return item ? item.value : null;
}

const onScanBarcode = async () => {
  if (!barcodeText.value) return;

  const companyQuery = `?company_id=${props.companyId}`;
  const query = `${companyQuery}&barcode_sku=${barcodeText.value}&location_id=${props.locationId}&is_service=1`;

  try {
    loader.value = true;

    const response = await fetchProductDropdownList(query);

    if (!response.status || response.data.length < 1) {
      showError('No product found with this barcode');
      barcodeText.value = null;
      loader.value = false
      return;
    }

    let foundProduct = response.data[0];
    foundProduct.name = response.data[0].text;
    foundProduct.stock_in_hand = response.data[0].stock_in_hand;
    foundProduct.sales_price = response.data[0].description ? response.data[0].description.sales_price : 0;

    isFromProductScan.value = true;
    addItem(foundProduct, 1, true);

    barcodeText.value = null;

    focusScanner();
  } catch (e) {
    showError('Failed to fetch product by barcode');
  } finally {
    loader.value = false;
  }
};

const openPaymentModal = () => {
    isPaymentModal.value = true;
}

const closeModal = () => {
  isPaymentModal.value = false;
}

async function submitData() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  organizeData();
  const handler = handlePurchase();
  const copyFormData = { ...formData.value };
  copyFormData.item_details = data.value;
  copyFormData.sale_master_receipt = true;
  try {
    const res = await handler.storeBillPayment(copyFormData);

    if(! res.status ) {
        showError(res.message);
        return;
    }

    showSuccess(res.message)
    closeModal()
    await goToPrint(res.data.id);
    resetForm();
    if(salesOrderId.value) {
     await goToOrderList()
    }
    await getProductList();
  } catch (e) {
    console.log(e);
  } finally {
    isSubmitting.value = false;
  }
}

const goToPrint = async (id) => {
  const user = store.state.user.user;
  const companyQuery = `?company_id=${props.companyId}`;
  const posPrint = customizationPdfFields.value && customizationPdfFields.value.heading_left_pos_print;

  try {
    const billRes = await fetchSalesBill(id, companyQuery);
    if (!billRes) return;

    invoiceRes.value = billRes.data;

    const qrcodeData = JSON.stringify({
      ref_no:             invoiceRes.value.bill_number,
      ref_date:           invoiceRes.value.date,
      created_by:         user.name,
      created_date_time:  formatDate(new Date())
    });
    barcodeQuery.value = `?code=${invoiceRes.value.bill_number}&qrcode=${qrcodeData}`;

    const barcodeRes = await fetchBarcode(barcodeQuery.value);
    barcode.value = barcodeRes.barcode;
    qrcode.value  = barcodeRes.qrcode;

    await nextTick();

    if (posPrint) {
      printPosReceipt();
      return;
    }

    exportToPDF(company.value, invoiceRes.value, barcode.value, qrcode.value, user.name, 1);

  } catch (e) {
    console.log(e)
  }
};

const selectedGroupId = ref(props.parentGroup.length ? props.parentGroup[0].id : null);

const goToOrderList = () => {
  delete route.query.sales_order_id
  router.push({
    name: 'pos-invoice',
    params: route.params,
    query: {
      ...route.query,
      selected_tab: 'order_list'
    }
  })
}

function organizeData() {
  formData.value.company_id = props.companyId;
  formData.value.date = date.currentDate();
  formData.value.location_id = props.locationId;
  formData.value.sales_order_master_id = salesOrderId.value ?? null;
  formData.value.adjustment_amount = discountAmount.value;
  data.value = data.value.map(item => ({
    ...item,
    total_amount: (Number(item.rate) || 0) * (Number(item.quantity) || 0),
  }));
}

const fetchSalesOrderData = async () => {
  const companyQuery = `?company_id=${props.companyId}`;
  try {
    loader.value = true;
    const res = await rest.fetchSalesOrderById(salesOrderId.value, companyQuery);

    if(!res.status){
      return
    }

    const order = res.data;
    discountAmount.value = order.adjustment_amount;
    formData.value.order_number = order.bill_number;
    formData.value.sales_order_master_id = order.id;

    if (order.contact) {
      contactProfile.value = order.contact;
      contactProfile.value.text = order.contact.full_name;
    }

    if (order.location_id) {
      emit('update:locationId', order.location_id);
    }

    formData.value.discount_head_id = order.discount_head_id;

    if (order.has_item_detail && order.general) {
      data.value = order.general.map(item => ({
        product_id: item.product_id,
        name: item.product ? item.product.name : item.name,
        quantity: item.quantity - (item.invoice_qty || 0),
        rate: item.rate,
        description: '',
        discount_percent: item.discount_percent || 0,
        discount_amount: item.discount_amount || 0,
        vat: item.vat || 0,
        vat_amount: item.vat_amount || 0,
        total: item.total_amount || 0,
        product: item.product || { name: item.name }
      }));
    }
  } catch (e) {
    showError("Failed to fetch Sales Order data");
  } finally {
    loader.value = false;
  }
}

const getActiveFiledCustomization = async () => {
  const companyQuery = `?company_id=${props.companyId}&customization_type=pdf&type=pos_invoice_pdf`;
  const res = await fetchActiveCustomizationField(companyQuery);
  customizationPdfFields.value = res.data;
};

const addServiceItem = (item, quantity = 1) => {
  if (!item) {
    showError('Product not found');
    return;
  }

  let alreadyExist = false;
  let existingIndex = -1;

  data.value.forEach((el, index) => {
    if (el.product_id === item.id) {
      alreadyExist = true;
      existingIndex = index;
    }
  });

  if (alreadyExist) {
    const existingItem = data.value[existingIndex];

    existingItem.quantity += quantity;
    changeQty(existingItem.quantity, existingIndex);
    return;
  }

  const product = { name: item.text };

  const newItem = {
    product_id: item.id,
    name: item.text,
    description: '',
    quantity,
    rate: item.description && item.description.sales_price,
    discount: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    discount_percent: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
    stock_in_hand:null,
    product
  };

  data.value.push(newItem);
}

const addItem = (item, quantity = 1, isBarcode = false) => {
  if (!item) {
    showError('Product not found');
    return;
  }

  if (item.product_type == 'finished_goods' && item.stock_in_hand !== undefined && item.stock_in_hand <= 0) {
    showError('Stock not available');
    return;
  }

  let alreadyExist = false;
  let existingIndex = -1;

  data.value.forEach((el, index) => {
    if (el.product_id === item.id) {
      alreadyExist = true;
      existingIndex = index;
    }
  });

  if (alreadyExist) {
    const existingItem = data.value[existingIndex];

    if (
      item.product_type == 'finished_goods' &&
      item.stock_in_hand !== undefined &&
      existingItem.quantity + quantity > item.stock_in_hand
    ) {
      showError('Stock limit exceeded');
      return;
    }

    existingItem.quantity += quantity;
    changeQty(existingItem.quantity, existingIndex);
    return;
  }

  const product = { name: item.name };

  const newItem = {
    product_id: item.id,
    name: item.stock_in_hand && !isBarcode
        ? `${item.name} | Stock: ${item.stock_in_hand}`
        : item.name,
    description: '',
    quantity,
    rate: item.sales_price ?? 0,
    discount: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    discount_percent: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
    stock_in_hand: item.stock_in_hand ?? null,
    product
  };

  data.value.push(newItem);
}

function deleteTableItem(index) {
  data.value.splice(index, 1);
}

const changeQty = (quantity, index) => {
  const item = data.value[index];

  if (quantity === '' || quantity === null) return;

  const qty = Number(quantity);

  if (isNaN(qty) || qty <= 0) {
    showError('Quantity must be a positive number');
    item.quantity = 1;
    return;
  }

  if (
    item.product_type == 'finished_goods' &&
    item.stock_in_hand !== null &&
    qty > item.stock_in_hand
  ) {
    showError('Stock limit exceeded');
    item.quantity = item.stock_in_hand;
    return;
  }

  item.quantity = qty;
  item.amount = item.rate * qty;
  item.total_amount = item.rate * qty;
}

const blurQty = (quantity, index) => {
  const item = data.value[index];
  const qty = Number(quantity);

  if (quantity === '' || quantity === null || isNaN(qty) || qty <= 0) {
    showError('Quantity must be a positive number');
    item.quantity = 1;
    item.amount = item.rate * 1;
    item.total_amount = item.rate * 1;
  }
}

const getAccountData = async () => {
    const dropdownRes = fetchDropdownList(getDropDownQuery());

    Promise.all([
        dropdownRes.then(res => {
          if(! res.status) return;

          if(res.data.account_head_list_by_slag.accounts_receivable) {
            accountRecHead.value = res.data.account_head_list_by_slag.accounts_receivable;
            formData.value.account_head_id = res.data.account_head_list_by_slag.accounts_receivable[0].id;
          }

          if(res.data.account_head_list_by_slag.vat_payable) {
            formData.value.vat_payable_account_head_id = res.data.account_head_list_by_slag.vat_payable[0].id;
          }

          if(res.data.account_head_list_by_slag.discount_account) {
            discountAccHead.value = res.data.account_head_list_by_slag.discount_account;
          }

          if(res.data.account_head_list_by_slag.cash_and_banks) {
            cashAndBank.value = res.data.account_head_list_by_slag.cash_and_banks;
            formData.value.mop_account_head_id = cashAndBank.value[0].id;
          }

          if(res.data.account_head_list_by_slag.reward_points) {
            rewardPointsAccountHeads.value = res.data.account_head_list_by_slag.reward_points;
          }
        }),
        fetchCompanyInfo(props.companyId).then(res=> {
          if(res.data) company.value = res.data;
        }),
        getActiveFiledCustomization()
    ]).finally(() => {loader.value=false})
}

const getDropDownQuery = () => {
  let query = `?company_id=${props.companyId}
    &is_account_heads=1
    &slags[]=discount_account
    &slags[]=reward_points
    &slags[]=vat_payable
    &slags[]=accounts_receivable
    &slags[]=cash_and_banks`;
                
  return query;
}

function resetForm() {
  data.value = [];
  discountAmount.value = 0;
  discountPercent.value = 0;
  formData.value = {
    ...formData.value,
    company_id: props.companyId,
    contact_profile_id: null,
    liability_head_id: null,
    account_head_id: accountRecHead.value[0].id,
    mop_account_head_id: cashAndBank.value[0].id,
    business_id: null,
    project_id: null,
    cost_centre_id: null,
    location_id: null,
    status: 'active',
    bill_number: '',
    date: '',
    has_item_detail: true,
    description: '',
    order_number: null,
    sales_person_id: null,
    commission_percent: null,
    lc_number: null,
    discount_amount: 0,
    discount_percent: 0,
    discount_head_id: discountAccHead.value[0].id,
    vat_amount: 0,
    payment: 0,
    points_redeemed: 0,
    sale_type: 'pos_invoice',
    receipt_type: 'pos_invoice',
    item_details: [{
      product_id: null,
      name: '',
      description: '',
      quantity: 1,
      rate: 0,
      discount_percent: 0,
      vat: 0,
      sub_total: 0,
      discount_amount: 0,
      vat_amount: 0,
      total: 0,
      is_edit: false,
    }]
  };
  resetDiscounts();
  focusScanner();
}

const selectGroup = (item) => {
    selectedGroupId.value = item.id;
    focusScanner();
}

const getProductList = async () => {
    const query = `?company_id=${props.companyId}&location_id=${props.locationId}`;

    try{
        const res = await fetchProductDetailsByParent(query, selectedGroupId.value);
        
        if(! res.status) {
          loader.value = false;
          return;
        }
        productList.value = res.data;
        focusScanner();
    }catch(e){
        console.log(e);
    }
    loader.value = false
}

watch(selectedGroupId, (newVal) => {
    if(newVal) {
        getProductList();
    }
})

watch(selectedProduct, async (newProduct) => {
    if (!newProduct) return;

    if (newProduct.product_type !== "services"){
      const res = await rest.fetchProductById(newProduct.id, `?company_id=${props.companyId}&location_id=${props.locationId}`);
      if(!res.status) return showError('Product not found');
      addItem(res.data, 1);
    }

    if (newProduct.product_type === "services") {
       addServiceItem(newProduct, 1);
    }
    
    selectedProduct.value = null;
    productField.value.clear();
});

watch(discountAmount, (newValue) => {
  if(newValue > 0 && discountAccHead.value.length > 0){
    formData.value.adjustment_amount = discountAmount.value;
  }
  if(newValue > 0 && discountAccHead.value.length > 0 && !formData.value.discount_head_id) {
    formData.value.discount_head_id = discountAccHead.value[0].id;
  }
})

watch(() => props.locationId, (newVal) => {
    if(newVal) {
        getProductList();
    }
})
</script>

<style scoped>
.content-height {
    height: 620px;
}
.padding-right {
    padding-right: 3rem;
}
.group-head {
    background: #5286d4;
    color: #fff;
}
.grp-pd {
    padding: 2px 0px;
}

.table-scroll {
    height: 300px !important;
}

.margin-5 {
    margin-top: 5px;
}

.content-border {
    margin-left: 1px;
    margin-right: 1px;
}
.pay-now-btn {
    background: #7367f0;
    color: #fff;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    cursor: pointer;
    font-size: 20px;
    border-radius: 10px;
}

.pos-right {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.pos-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

.cal-border {
    border-top: 3px solid;
}

.bg-col-1 {
    background-color: rgba(115, 103, 240, 0.12);
    padding-right: 0px;
}

.bg-col-2 {
    background-color: rgba(40, 199, 111, 0.12);
}

.bg-col-3 {
    background-color: rgba(255, 159, 67, 0.12);
}

.table {
  table-layout: fixed;
  width: 100%;
}

.table th:nth-child(1),
.table td:nth-child(1) {
  width: 8%;
}

.table th:nth-child(2),
.table td:nth-child(2) {
  width: 45%; /* ITEM → BIG */
}

.table th:nth-child(3),
.table td:nth-child(3),
.table th:nth-child(4),
.table td:nth-child(4),
.table th:nth-child(5),
.table td:nth-child(5) {
  width: 15%; /* Qty, Price, Amount */
}

.table th:nth-child(6),
.table td:nth-child(6) {
  width: 5%; /* delete */
}
.custom-header-card{
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
.custom-card-body{
  padding: 0 10px !important;
}
</style>